<template>
    <div>
        <transition-group 
            name="alert" 
            tag="div"
            enter-active-class="animated slideInLeft"
            leave-to-class="animated slideOutLeft"
        > 
            <div :class="['alert', alert.alertClass, 'w-1/2']" role="alert" v-for="( alert, index ) in alerts" v-bind:key="index + 0">
                <div class="alert-inner-message">
                    <span class="alert-message" v-html="alert.alertMessage"></span>
                </div>

                <div class="alert-inner-close" v-if="alert.alertImportant">
                    <a class="close" v-on:click.prevent="dismiss( alert.ident )" aria-label="Close">
                        <i class="fas fa-fw fa-2x fa-times"></i>
                    </a>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                alerts: 'allAlerts'
            })
        },
        data: () => {
            return {
            }
        },
        mounted() {
        },

        methods: {
            // Map the Methods from the State Module
            ...mapActions(['addAlert', 'dismissAlert']),

            // Method to Dismiss the Alert.
            // calls the Store Mapped Method
            dismiss: function( ident ) {
                this.dismissAlert( ident )
            }

        }
    }
</script>

<style>
    .alert-enter-active {
        transition: all .3s ease;
    }
    .alert-leave-active {
        transition: all 0.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .alert-enter {
        transform: translateY(10px);
        opacity: 0;
    }

    .alert-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(-10px);
        opacity: 0;
    }
</style>
